/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BenefitsTopUpReferenceObjectTypeApiModel } from './benefits-top-up-reference-object-type';
import { CouponTypeApiModel } from './coupon-type';
import { CouponProcessingStatusApiModel } from './coupon-processing-status';
import { CouponExternalCodeVisibilityTypeApiModel } from './coupon-external-code-visibility-type';
import { PromotionalBonusesExpireTypeBaseApiModel } from './promotional-bonuses-expire-type-base';
import { BenefitsPriceTypeApiModel } from './benefits-price-type';
import { BenefitsChargeTypeBaseApiModel } from './benefits-charge-type-base';
import { CouponStatusApiModel } from './coupon-status';
import { LoyaltyApiModel } from './loyalty';
import { CouponBatchApiModel } from './coupon-batch';

export interface CouponApiModel {
  /**
   * Activity ID (optional, check only)
   */
  activity_id?: string | null;
  /**
   * Coupon check applicable for check (optional, check only)
   */
  applicable?: boolean | null;
  batch?: CouponBatchApiModel;
  /**
   * Business code
   */
  business_code?: string | null;
  /**
   * Coupon certificate type refill amount (optional)
   */
  charge_amount?: number | null;
  /**
   * currency (optional)
   */
  charge_bonuses_currency?: string | null;
  /**
   * Value of promotional bonuses expire date (optional)
   */
  charge_promotional_bonuses_expire_date?: string | null;
  charge_promotional_bonuses_expire_type?: PromotionalBonusesExpireTypeBaseApiModel;
  /**
   * Value of promotional bonuses expire (optional)
   */
  charge_promotional_bonuses_expire_value?: number | null;
  /**
   * Special account currency (optional)
   */
  charge_special_account_currency?: string | null;
  /**
   * Special account ID (optional)
   */
  charge_special_account_id?: string | null;
  /**
   * Special account title (optional)
   */
  charge_special_account_title?: string | null;
  charge_type?: BenefitsChargeTypeBaseApiModel;
  /**
   * Coupon code
   */
  code?: string | null;
  /**
   * Coupon emission price (optional)
   */
  customers_price_amount?: number | null;
  /**
   * Coupon emission price currency (optional)
   */
  customers_price_currency?: string | null;
  /**
   * Coupon emission price special account Id (optional)
   */
  customers_price_special_account_id?: string | null;
  /**
   * Coupon emission price special account title (optional)
   */
  customers_price_special_account_title?: string | null;
  customers_price_type?: BenefitsPriceTypeApiModel;
  /**
   * Coupon Description
   */
  description?: string | null;
  /**
   * Do not add emitted coupons to the customer\'s wallet (optional, check only)
   */
  do_not_add_to_wallet?: boolean | null;
  /**
   * Date emission of coupon
   */
  emission_dt?: string | null;
  /**
   * Coupon check implementation error (optional, check only)
   */
  error?: string | null;
  /**
   * Date expiry of coupon
   */
  expire_date?: string | null;
  /**
   * Coupon external_code
   */
  external_code?: string | null;
  external_code_visibility_type?: CouponExternalCodeVisibilityTypeApiModel;
  /**
   * Unique id of coupon
   */
  id?: string | null;
  image?: string | null;
  /**
   * Coupon locked by transaction process (optional)
   */
  locked?: boolean | null;
  loyalty?: LoyaltyApiModel;
  /**
   * Loyalty emission id
   */
  loyalty_id?: string | null;
  /**
   * Reference object ID, up to 36 chars (optional, check only)
   */
  object_id?: string | null;
  object_type?: BenefitsTopUpReferenceObjectTypeApiModel;
  processing_status?: CouponProcessingStatusApiModel;
  /**
   * Recommendation fee amount
   */
  recommendation_fee_amount?: number | null;
  /**
   * Recommendation fee bonuses currence ISO code (optional)
   */
  recommendation_fee_bonuses_currency?: string | null;
  /**
   * Recommendation fee Batch CODE (optional)
   */
  recommendation_fee_coupon_batch_code?: string | null;
  /**
   * Recommendation fee Batch Id (optional)
   */
  recommendation_fee_coupon_batch_id?: string | null;
  /**
   * Recommendation fee Batch TITLE (optional)
   */
  recommendation_fee_coupon_batch_title?: string | null;
  /**
   * Value of recommendation fee promotional bonuses expire date (optional)
   */
  recommendation_fee_promotional_bonuses_expire_date?: string | null;
  recommendation_fee_promotional_bonuses_expire_type?: PromotionalBonusesExpireTypeBaseApiModel;
  /**
   * Value of recommendation fee promotional bonuses expire (optional)
   */
  recommendation_fee_promotional_bonuses_expire_value?: number | null;
  /**
   * Special account ID (optional)
   */
  recommendation_fee_special_account_id?: string | null;
  /**
   * Recommendation fee special account title (optional)
   */
  recommendation_fee_special_account_title?: string | null;
  /**
   * Recommendation fee type
   */
  recommendation_fee_type?: CouponApiModelRecommendationFeeTypeEnum | null;
  /**
   * Redeem only at terminal restriction
   */
  redeem_at_terminal?: number | null;
  /**
   * Coupons share allowed for customer
   */
  share_allowed?: number | null;
  status?: CouponStatusApiModel;
  /**
   * Coupon Title
   */
  title?: string | null;
  type?: CouponTypeApiModel;
}
export enum CouponApiModelRecommendationFeeTypeEnum {
  None = 'none',
  RegularBonuses = 'regular-bonuses',
  PromotionalBonuses = 'promotional-bonuses',
  SpecialAccount = 'special-account',
  Coupon = 'coupon'
}
